import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';

import { SiteDateFilterMenuComponent } from './components/site-date-filter-menu/site-date-filter-menu.component';
import { SiteFilterMenuComponent } from './components/site-filter-menu/site-filter-menu.component';
import { SiteFiltersComponent } from './components/site-filters/site-filters.component';
import { SiteFilterRestConnectorService } from './services/site-filter-rest-connector.service';
import { SiteFilterService } from './services/site-filter.service';
import { SiteFilterEffects } from './state/site-filter-effects';
import { siteFilterReducer } from './state/site-filter.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('siteFilter', siteFilterReducer),
    EffectsModule.forFeature([
      SiteFilterEffects,
    ]),
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
  providers: [
    SiteFilterService,
    SiteFilterRestConnectorService,
    SiteFilterEffects,
  ],
  declarations: [
    SiteFiltersComponent,
    SiteDateFilterMenuComponent,
    SiteFilterMenuComponent,
  ],
  exports: [
    SiteFiltersComponent,
    SiteDateFilterMenuComponent,
    SiteFilterMenuComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
  export class SiteFiltersModule { }
